import { Input } from '@/components/ui/input/input.component';
import { Textarea } from '@/components/ui/textarea/textarea.component';
import { ControllerRenderProps } from 'react-hook-form';
import * as z from 'zod';
import { SelectInput, SelectInputOption } from '../select-input/select-input.component';

export type MappedFormItem = {
  name: string;
  label: string;
  placeholder: string;
  required: boolean;
  disabled?: boolean;
  type: 'input' | 'textarea' | 'select';
  options?: SelectInputOption[];
};

export const genericSchema = <T extends z.ZodTypeAny>(schema: T) => schema;

export const determineInputField = (
  mappedField: MappedFormItem,
  field: ControllerRenderProps<any, string>,
  context: string,
) => {
  let Component;
  let options: SelectInputOption[] | undefined = undefined;

  if (mappedField.type === 'input') {
    Component = Input;
  } else if (mappedField.type === 'textarea') {
    Component = Textarea;
  } else if (mappedField.type === 'select') {
    options = mappedField.options;
    Component = SelectInput;
  }

  if (!Component) return null;

  return (
    <Component
      data-testid={`${context}-form-field-${mappedField.name}`}
      options={options || []}
      placeholder={mappedField.placeholder}
      {...field}
      disabled={mappedField.disabled}
    />
  );
};
